import { render } from "./todo-list-modal.vue?vue&type=template&id=0a030a9f"
import script from "./todo-list-modal.vue?vue&type=script&lang=js"
export * from "./todo-list-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__